import {Link, redirect, useLoaderData, useParams} from "react-router-dom";
import HttpRequest from "../../services/Request";
import TournamentComponent from '../../components/Tournament'
import Cookies from "js-cookie";
import {Image} from "antd";
import BackButton from "../../components/BackButton";

const ScientificContest = () => {
    const {tournament, sc} = useLoaderData();
    const description_url = sc.find(c => c.name === 'd').file
    const errors_url = sc.find(c => c.name === 'e').file
    const tools_url = sc.find(c => c.name === 't').file
    const params = useParams();
    return <div>
        <BackButton src={`/tournament/${params.id}/steps`} />
        <div className="flex items-center">
            <TournamentComponent tournament={tournament}/>
        </div>
        <div className="flex items-center mt-2">
            <div className="flex flex-wrap w-[97%]  md:w-[90%] rounded-[15px]  mx-auto mt-1 md:mt-0 md:mb-2 p-2 py-5">
                <div className="w-[80%] md:w-[27%] md:mt-5 text-center p-3 mx-auto shadow mt-3 bg-gray2 text-orange">
                   مسابقه علمی
                </div>
            </div>
        </div>
        <div className="mt-2">
            <div
                className="flex flex-wrap w-[97%] md:w-[90%] rounded-[15px] mx-auto mt-1 md:mt-0 md:mb-2 bg-white p-2 py-5">
                <a href={description_url}
                   className="w-[80%] md:w-[22%] md:mt-5 text-center p-3  mx-auto  shadow mt-3 bg-gray2 text-white font-bold">
                    <img src="/icons/step-description.png" className={`inline mx-2`} alt=""/>
                    <span className="text-[18px]">شرح مسابقه</span>
                </a>
                <a href={errors_url}
                   className="w-[80%] md:w-[22%] md:mt-5 text-center p-3  mx-auto  shadow mt-3 bg-gray2 text-white font-bold">
                    <img src="/icons/step-errors.png" className={`inline mx-2`} alt=""/>
                    <span className="text-[18px]">خطاهای مسابقه</span>
                </a>
                <a href={tools_url}
                   className="w-[80%] md:w-[22%] md:mt-5 text-center p-3  mx-auto  shadow mt-3 bg-gray2 text-white font-bold">
                    <img src="/icons/step-tools.png" className={`inline mx-2`} alt=""/>
                    <span className="text-[18px]">تجهیزات مورد نیاز</span>
                </a>
            </div>
        </div>
    </div>
}

export default ScientificContest

export async function ScientificContestPageLoader({params}) {
    let data = []
    try {
        await HttpRequest(`${process.env.REACT_APP_DOMAIN}/user/tournament/${params.id}/step/scientific-contest`, (res) => {
                data = res.data;
            }, 'get', [], (err) => {
                let error = new Error();
                error.status = err.response.status
                throw error
            }
        )
    } catch (err) {
        if (err.status === 401) {
            Cookies.remove('access_token')
            return redirect('/login')
        }
    }
    return data;
}